export const environment = {
  production: true,
  convert_api_url: 'https://converter.e-ugovor.com/convert.php',
  firebase_apiKey: 'AIzaSyBL8AlUVN6mEMGh4roiZBiZydM-U2euFcs',
  firebase_authDomain: 'selflegal-c9be5.firebaseapp.com',
  firebase_databaseURL: 'https://selflegal-c9be5.firebaseio.com',
  firebase_projectId: 'selflegal-c9be5',
  firebase_storageBucket: 'selflegal-c9be5.appspot.com',
  firebase_messagingSenderId: '551507723691'
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/environments/environment.ts